import { render, staticRenderFns } from "./AtomTogglePrimary.vue?vue&type=template&id=bd5e5b20"
import script from "./AtomTogglePrimary.vue?vue&type=script&lang=js"
export * from "./AtomTogglePrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports